const PageHeader = () => {

    return (
        <div className="page-header">    
            <h1>Letter Count</h1>
            <h3>By Ian Roberts</h3>
        </div>  );
}
 
export default PageHeader;